<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Booking History</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row align-items-center">
            <div class="col-md-2 fit-content">Type of Pass</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="passId">
                    <option value="">All</option>
                    <option v-for="(item, i) in passes" :key="i" :value="item.Id">
                        {{ item.Name }}
                    </option>
                </select>
            </div>
            
            <div class="col-md-1 fit-content">Status</div>
            <div class="col-md-4 pl-md-0">
                <select class="custom-select" v-model="status">
                    <option value="">ALL</option>
                    <option value="BOOKED">BOOKED</option>
                    <option value="COLLECTED">COLLECTED</option>
                    <option value="RETURNED">RETURNED</option>
                    <option value="CANCELLED">CANCELLED</option>
                </select>
            </div>
        </div>
        <div class="row align-items-center mt-2">
            <div class="col-md-2 fit-content mr-3">Date From</div>
            <div class="col-md-4">
                <div class="row align-items-center"> 
                    <div class="col-md-5 pl-md-0 pr-1 fit-content">
                        <input type="date" class="form-control" v-model="fromDate" />
                    </div>
                    <div class="col-md-1 px-md-0 fit-content">To</div>
                    <div class="col-md-5 pl-1 fit-content ">
                        <input type="date" class="form-control" :min="fromDate" v-model="toDate" />
                    </div>
                </div>
            </div>

            <template v-if="role == 'employee'">
                <div class="col-md-1 ml-4">
                    <button type="button" class="btn btn-primary" @click="search">Search</button>
                </div>
            </template>
            <template v-if="role == 'admin'">
                <div class="col-md-2" style="max-width:100px">Employee Name/ID</div>
                <div class="col-md-4 pl-md-0">
                    <Select2 v-model="userId" :options="employees" />
                </div>
            </template>
        </div>

        <div v-if="fromDate || toDate" class="mt-2 row">
            <div class="col-md-1">
            </div>
            <div class="col-md-2 pl-md-0">
                <button type="button" class="btn btn-secondary" @click="resetDate">
                    Reset Date
                </button>
            </div>
        </div>

        <div class="row align-items-center mt-3" v-if="role == 'admin'">
            <div class="col-md-11 text-center">
                <button type="button" class="btn btn-primary" @click="search">Search</button>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Pagination -->
        <div :class="role == 'employee' ? 'row mt-5' : 'row'">
            <div class="col-md-6">
                Show
                <select class="custom-select" v-model="paging.SizePerPage" style="width: 5em">
                    <option v-for="item in paging.Sizes" v-bind:key="item" v-bind:value="item">
                        {{ item }}
                    </option>
                </select>
                entries
            </div>
        </div>
        <!-- /Pagination -->

        <!-- Table List -->
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>Pass</th>
                                <th v-if="role == 'admin'">Employee</th>
                                <th v-if="role == 'admin'">Mobile Number</th>
                                <th style="width:5%">Number of Pass/e-Tickets</th>
                                <th style="width:10%">Collection Date</th>
                                <th style="width:10%">Booking Date</th>
                                <th style="width:10%">Return Date</th>
                                <th style="width:5%">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in records" :key="item.Id">
                                <td>{{ item.PassName + '(' + item.PassCode + ')' }}</td>
                                <td v-if="role == 'admin'">{{ item.EmployeeName + ' (' + item.EmployeeID + ')' }}</td>
                                <td v-if="role == 'admin'">{{ item.MobileNumber }}</td>
                                <td>{{ item.NumberOfPass }}</td>
                                <td>{{ item.CollectionDateDisplay }}</td>
                                <td class="link-underline">
                                    <router-link :to="{
                                        name: 'bookingDetail',
                                        params: { id: item.Id },
                                    }">
                                        {{ item.BookingDateDisplay }}
                                    </router-link>
                                </td>
                                <td>{{ item.ReturnDateDisplay }}</td>
                                <td>{{ item.Status }}</td>
                            </tr>
                            <tr v-if="records && !records.length">
                                <td :colspan="role == 'admin' ? '7' : '6'" class="text-center">
                                    {{ this.noRecordText }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->

        <!--Pagination -->
        <div class="row mb-4" v-if="records && records.length">
            <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
                Showing
                {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
                to
                {{
                        paging.CurrentPage * paging.SizePerPage -
                        paging.SizePerPage +
                        records.length
                }}
                of {{ totalRecords }} entries
            </div>

            <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
                <div class="navbar justify-content-end">
                    <button v-on:click="first()" v-if="paging.CurrentPage != 1" class="btn btn-white">
                        First
                    </button>
                    <button v-on:click="prev()" class="btn btn-white ml-1 mr-3" v-if="paging.CurrentPage > 1">
                        Prev
                    </button>
                    Page
                    <input class="form-control form-control-sm mx-1" type="number" step="1" min="1"
                        :max="paging.TotalPage" v-model="paging.CurrentPage" @change="onCurrentPageChange($event)"
                        style="width: 4rem" />

                    <span>of {{ paging.TotalPage }}</span>
                    <button v-on:click="next()" class="btn btn-white ml-3 mr-1"
                        v-if="paging.CurrentPage < paging.TotalPage">
                        Next
                    </button>
                    <button v-on:click="last()" v-if="paging.CurrentPage != paging.TotalPage" class="btn btn-white">
                        Last
                    </button>
                </div>
            </div>
        </div>
        <!--/Pagination -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            records: [],
            passes: [],
            passId: "",
            status: "",
            fromDate: "",
            toDate: "",
            employees: [],
            userId: "00000000-0000-0000-0000-000000000000",
            noRecordText: config.NO_RECORD_TEXT,
            //paging
            paging: {
                Search: "",
                CurrentPage: 1,
                TotalPage: "",
                SizePerPage: 100,
                Sizes: [5, 10, 20, 100],
                SortBy: "",
            },
            totalRecords: "",
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        }
    },

    watch: {
        "paging.SizePerPage": function (val, oldVal) {
            this.paging.CurrentPage = 1;
            this.getCorporatePassBookingHistory();
        },
        "paging.CurrentPage": function (val, oldVal) {
            if (val > this.paging.TotalPage) {
                this.paging.CurrentPage = this.paging.TotalPage;
            }
        },
    },

    methods: {
        //filter
        resetDate() {
            this.fromDate = "";
            this.toDate = "";
        },
        getPasses() {
            let param = {
                Token: this.token,
                Company: config.DEFAULT_COMPANY
            }
            this.$store.state.isLoading = true;
            API.getCorporatePass(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.passes = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getEmployees() {
            let param = { Token: this.token };
            this.$store.state.isLoading = true;
            API.getEmployees(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        response.data.record.unshift({ department: "", id: "00000000-0000-0000-0000-000000000000", text: "All" });
                        this.employees = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //table
        getCorporatePassBookingHistory() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            let userId = data.Id;
            let param = {
                Token: this.token,
                Search: this.paging.Search,
                CurrentPage: this.paging.CurrentPage,
                TotalPage: this.paging.TotalPage,
                SizePerPage: this.paging.SizePerPage,
                SortBy: this.paging.SortBy,
                PassId: this.passId,
                Status: this.status,
                FromDate: this.fromDate,
                ToDate: this.toDate,
                UserId: this.role == "admin" ? this.userId : userId
            }
            this.$store.state.isLoading = true;
            API.getCorporatePassBookingHistory(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.records = response.data.record;
                        this.totalRecords = response.data.total;
                        this.paging.TotalPage = response.data.pageCount;
                        if (this.paging.CurrentPage > this.paging.TotalPage) {
                            this.paging.CurrentPage = 1;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //action
        search() {
            this.getCorporatePassBookingHistory();
        },
        //pagination method
        onCurrentPageChange(event) {
            let currentPage = event.target.value;
            if (currentPage < 1) {
                currentPage = 1;
            }
            this.paging.CurrentPage = parseInt(currentPage);
            this.getCorporatePassBookingHistory();
        },
        first() {
            this.paging.CurrentPage = 1;
            this.getCorporatePassBookingHistory();
        },
        prev() {
            this.paging.CurrentPage -= 1;
            this.getCorporatePassBookingHistory();
        },
        next() {
            this.paging.CurrentPage += 1;
            this.getCorporatePassBookingHistory();
        },
        last() {
            this.paging.CurrentPage = this.paging.TotalPage;
            this.getCorporatePassBookingHistory();
        },
    },

    created() {
        this.getPasses();
        this.getEmployees();
        this.getCorporatePassBookingHistory();
    }

}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}

.link-underline a:hover {
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/ManagePassBookingHistory.vue